import { AppNotification } from "../models/Notification/AppNotification";
import { ResponseObject } from "../models/ResponseObject";
import { AxiosConfig } from "./AxiosConfig";


const GetHeaderNotificationList = async (
    successCallback: (noticationList: Array<AppNotification>) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get("/Notification/GetNotifications");
      successCallback(resp.data.notifications);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

  const readNotification = async (
    notificationId:number,
    successCallback: (responseData: ResponseObject) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.post("Notification/SetViewed", notificationId);
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

  const readNotificationsCount = async (
    successCallback: (notifictaionCount: number) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get("/Notification/GetNotifications");
      successCallback(resp.data.notificationCount);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };
  

export const NotificationService = {
    GetHeaderNotificationList,
    readNotification,
    readNotificationsCount
};